module.exports = __webpack_public_path__ + "static/img/product_safety.9a04e39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/product_safety.jpg
// module id = US12
// module chunks = 0